import { cn, tv } from "@pcln/horizon";
const carFormVariants = {
    differentDropOff: {
        gridContainer: 'grid-cols-[minmax(0,1fr)_minmax(0,1fr)] @3xl:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)] @7xl:grid-cols-[minmax(0,0.4fr)_minmax(0,0.4fr)_minmax(0,0.3fr)_minmax(0,0.3fr)_minmax(0,0.3fr)_minmax(0,0.3fr)_max-content]',
        pickupInput: 'col-span-full @7xl:[grid-area:unset]',
        dualPickupInput: 'col-span-2 @7xl:[grid-area:unset]',
        dropoffInput: 'col-span-2 @7xl:[grid-area:unset]',
        packageInput: 'flex flex-row items-center justify-start gap-4 text-body2 @3xl:col-span-2 @3xl:self-stretch @3xl:items-stretch col-span-full',
        submitInput: 'col-span-2 @3xl:col-end-[-1] @7xl:[grid-area:unset]'
    },
    sameDropOff: {
        gridContainer: 'grid-cols-[minmax(0,1fr)_minmax(0,1fr)] @3xl:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)] @7xl:grid-cols-[minmax(0,0.8fr)_minmax(0,0.4fr)_minmax(0,0.3fr)_minmax(0,0.4fr)_minmax(0,0.3fr)_max-content]',
        pickupInput: 'col-span-full @7xl:[grid-area:unset]',
        dualPickupInput: 'col-span-2 @7xl:[grid-area:unset]',
        dropoffInput: 'col-span-2 @7xl:[grid-area:unset]',
        packageInput: 'flex flex-row items-center justify-start gap-4 text-body2 @3xl:col-span-2 @3xl:self-stretch @3xl:items-stretch col-span-full',
        submitInput: 'col-span-2 @3xl:col-end-[-1] @7xl:[grid-area:unset]'
    },
    hotelOnly: {
        gridContainer: 'grid-cols-2 @7xl:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_max-content]',
        pickupInput: 'col-span-full @7xl:[grid-area:unset]',
        dualPickupInput: 'col-span-2 @7xl:[grid-area:unset]',
        dropoffInput: 'col-span-2 @7xl:[grid-area:unset]',
        packageInput: 'flex flex-row items-center justify-start gap-4 text-body2 col-span-full @3xl:col-span-1 @3xl:self-stretch @3xl:items-stretch',
        submitInput: 'col-span-2 @3xl:col-span-1 @3xl:col-end-[-1] @7xl:[grid-area:unset]'
    },
    withFlight: {
        gridContainer: 'grid-cols-2 @7xl:grid-cols-[minmax(0,0.9fr)_minmax(0,0.9fr)_minmax(0,0.8fr)_minmax(0,0.7fr)_max-content]',
        pickupInput: 'col-span-full @7xl:[grid-area:unset]',
        dualPickupInput: 'col-span-2 @7xl:[grid-area:unset]',
        dropoffInput: 'col-span-2 @7xl:[grid-area:unset]',
        packageInput: 'flex flex-row items-center justify-start gap-4 text-body2 col-span-full @3xl:col-span-1 @3xl:self-stretch @3xl:items-stretch',
        submitInput: 'col-span-2 @3xl:col-span-1 @3xl:col-end-[-1] @7xl:[grid-area:unset]'
    }
};
const backButtonGridOverrides = {
    differentDropOff: '@5xl:grid-cols-[max-content_minmax(0,0.4fr)_minmax(0,0.4fr)_minmax(0,0.3fr)_minmax(0,0.3fr)_minmax(0,0.3fr)_minmax(0,0.3fr)_max-content] @7xl:grid-cols-[max-content_minmax(0,0.4fr)_minmax(0,0.4fr)_minmax(0,0.3fr)_minmax(0,0.3fr)_minmax(0,0.3fr)_minmax(0,0.3fr)_max-content]',
    sameDropOff: '@5xl:grid-cols-[max-content_minmax(0,0.8fr)_minmax(0,0.4fr)_minmax(0,0.3fr)_minmax(0,0.4fr)_minmax(0,0.3fr)_max-content] @7xl:grid-cols-[max-content_minmax(0,0.8fr)_minmax(0,0.4fr)_minmax(0,0.3fr)_minmax(0,0.4fr)_minmax(0,0.3fr)_max-content]',
    hotelOnly: '@5xl:grid-cols-[max-content_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_max-content] @7xl:grid-cols-[max-content_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_max-content]',
    withFlight: '@5xl:grid-cols-[max-content_minmax(0,0.9fr)_minmax(0,0.9fr)_minmax(0,0.8fr)_minmax(0,0.7fr)_max-content] @7xl:grid-cols-[max-content_minmax(0,0.9fr)_minmax(0,0.9fr)_minmax(0,0.8fr)_minmax(0,0.7fr)_max-content]'
};
const carFormSingleRowCompoundVariants = [
    {
        carType: 'differentDropOff',
        singleRow: true,
        class: {
            gridContainer: 'grid-cols-[minmax(0,1fr)_minmax(0,1fr)] @3xl:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] @5xl:grid-cols-[minmax(0,0.4fr)_minmax(0,0.4fr)_minmax(0,0.3fr)_minmax(0,0.3fr)_minmax(0,0.3fr)_minmax(0,0.3fr)_max-content]',
            pickupInput: '@5xl:[grid-area:unset]',
            dualPickupInput: 'col-span-2 @5xl:[grid-area:unset]',
            dropoffInput: 'col-span-2 @5xl:[grid-area:unset]',
            packageInput: '@3xl:col-span-full',
            submitInput: 'col-span-2 @3xl:col-end-auto @5xl:[grid-area:unset]'
        }
    },
    {
        carType: 'sameDropOff',
        singleRow: true,
        class: {
            gridContainer: 'grid-cols-[minmax(0,1fr)_minmax(0,1fr)] @3xl:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] @5xl:grid-cols-[minmax(0,0.8fr)_minmax(0,0.4fr)_minmax(0,0.3fr)_minmax(0,0.4fr)_minmax(0,0.3fr)_max-content]',
            pickupInput: '@5xl:[grid-area:unset]',
            dualPickupInput: 'col-span-2 @5xl:[grid-area:unset]',
            dropoffInput: 'col-span-2 @5xl:[grid-area:unset]',
            packageInput: '@3xl:col-span-full',
            submitInput: 'col-span-2 @3xl:col-end-auto @5xl:[grid-area:unset]'
        }
    },
    {
        carType: 'hotelOnly',
        singleRow: true,
        class: {
            gridContainer: 'grid-cols-2 @3xl:grid-cols-2 @5xl:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_max-content]',
            pickupInput: '@5xl:[grid-area:unset]',
            dualPickupInput: 'col-span-2 @5xl:[grid-area:unset]',
            dropoffInput: 'col-span-2 @5xl:[grid-area:unset]',
            packageInput: '@3xl:col-span-full',
            submitInput: 'col-span-2 @3xl:col-span-2 @3xl:col-end-auto @5xl:[grid-area:unset]'
        }
    },
    {
        carType: 'withFlight',
        singleRow: true,
        class: {
            gridContainer: 'grid-cols-2 @3xl:grid-cols-2 @5xl:grid-cols-[minmax(0,0.9fr)_minmax(0,0.9fr)_minmax(0,0.8fr)_minmax(0,0.7fr)_max-content]',
            pickupInput: '@5xl:[grid-area:unset]',
            dualPickupInput: 'col-span-2 @5xl:[grid-area:unset]',
            dropoffInput: 'col-span-2 @5xl:[grid-area:unset]',
            packageInput: '@3xl:col-span-full',
            submitInput: 'col-span-2 @3xl:col-span-2 @3xl:col-end-auto @5xl:[grid-area:unset]'
        }
    }
];
const carFormSlots = {
    gridContainer: 'isolate grid grid-cols-1 gap-3 items-center mx-auto',
    optionsWrapper: 'col-span-full',
    pickupInput: '',
    dualPickupInput: '',
    dropoffInput: '',
    packageInput: '',
    submitInput: '',
    datePickerWrapper: '',
    packageDatePickerWrapper: 'col-span-full @3xl:col-span-1',
    flightInput: 'col-span-full @3xl:[grid-area:unset]'
};
const horizonCarForm = tv({
    slots: carFormSlots,
    variants: {
        carType: carFormVariants,
        singleRow: {
            true: {
                gridContainer: 'gap-2'
            },
            false: {}
        }
    },
    compoundVariants: carFormSingleRowCompoundVariants,
    defaultVariants: {
        carType: 'sameDropOff',
        singleRow: false
    }
});
const getCarVariant = (isDifferentDropOff, isHotel, isFlight)=>{
    if (isFlight) return 'withFlight';
    if (isHotel) return 'hotelOnly';
    if (isDifferentDropOff) return 'differentDropOff';
    return 'sameDropOff';
};
const getWideLayoutBreakpointPx = (singleRow)=>singleRow ? 1024 : 1280;
const getGridContainerClass = (isDifferentDropOff = false, isHotel = false, isFlight = false, singleRow = false, hasBackButton = false)=>{
    const carVariant = getCarVariant(isDifferentDropOff, isHotel, isFlight);
    const styles = horizonCarForm({
        carType: carVariant,
        singleRow
    });
    return cn(styles.gridContainer(), singleRow && hasBackButton && backButtonGridOverrides[carVariant]);
};
const getInputClass = (type, isDifferentDropOff = false, isHotel = false, isFlight = false, singleRow = false)=>{
    if ('datePickerWrapper' === type) return carFormSlots.datePickerWrapper;
    if ('packageDatePickerWrapper' === type) return carFormSlots.packageDatePickerWrapper;
    if ('flightInput' === type) return carFormSlots.flightInput;
    if ('back' === type) return 'hidden @5xl:inline-flex shrink-0 items-center whitespace-nowrap';
    const carVariant = getCarVariant(isDifferentDropOff, isHotel, isFlight);
    const styles = horizonCarForm({
        carType: carVariant,
        singleRow
    });
    switch(type){
        case 'pickup':
            return isDifferentDropOff ? styles.dualPickupInput() : styles.pickupInput();
        case 'options':
            return styles.optionsWrapper();
        case 'dropoff':
            return styles.dropoffInput();
        case 'package':
            return styles.packageInput();
        case 'submit':
            return styles.submitInput();
        default:
            return '';
    }
};
export { getGridContainerClass, getInputClass, getWideLayoutBreakpointPx, horizonCarForm };
